import React, { useState } from 'react';
import { TextField, Button, Box, Typography, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { changepasswordfun } from '../../../components/Apis';
import Swal from 'sweetalert2';

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      Swal.fire("New password and confirmation don't match");

    } else {

const changepassword = {
    old_password: currentPassword,
    new_password: newPassword,
    new_password_confirmation: confirmPassword
}
const res = await changepasswordfun(changepassword)
console.log(res)

      if(res.message=== "Password changed successfully."){
        Swal.fire("Password changed successfully");
        setCurrentPassword('')
        setNewPassword('')
        setConfirmPassword('')
      }
      else if(res.message=== "Old password is incorrect."){
        Swal.fire("Old password is incorrect");
     
      }
    }
  };

  return (
    <Box sx={{ padding: '20px', maxWidth: '40%', margin: '0 auto', direction: 'ltr' }}>
      <Typography variant="h5" gutterBottom>
        Change Password
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Current Password"
          type={showCurrentPassword ? 'text' : 'password'}
          fullWidth
          margin="normal"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          InputProps={{
            endAdornment: (  // تغييرها إلى 'end' بدلاً من 'start' لجعل الأيقونة في الجهة اليمنى
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                >
                  {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            sx: { textAlign: 'left' },
          }}
        />
        <TextField
          label="New Password"
          type={showNewPassword ? 'text' : 'password'}
          fullWidth
          margin="normal"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            sx: { textAlign: 'left' },
          }}
        />
        <TextField
          label="Confirm New Password"
          type={showConfirmPassword ? 'text' : 'password'}
          fullWidth
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            sx: { textAlign: 'left' },
          }}
        />
       <Button
  type="submit"
  variant="contained"
  sx={{
    width: '100%',
    marginTop: '20px',
    backgroundColor: "#C47D60",
    '&:hover': {
      backgroundColor: "#C47D60", // نفس اللون عند التمرير
    },
  }}
>
          Change Password
        </Button>
      </form>
    </Box>
  );
};

export default ChangePassword;
